import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class SubReseller {
  private readonly http = inject(HttpClient);

  getCompanyList(filters: any = {}): Observable<any> {
    return this.http.get<any>(`${environment.apiPrefix}${environment.user.companyList}`, {
      params: filters
    });
  }

  getSubResellers(filters: any = {}): Observable<any> {
    return this.http.get<any>(`${environment.apiPrefix}${environment.user.userList}`, {
      params: filters
    });
  }

  getPackages(filters: any = {}): Observable<any> {
    return this.http.get<any>(
      `${environment.apiPrefix}${environment.userPackage.resellersPackages}`,
      {
        params: filters
      }
    );
  }

  getResellerDetails(filters: any = {}) {
    return this.http.get<any>(`${environment.apiPrefix}${environment.user.resellers}`, {
      params: filters
    });
  }

  addSubReseller(data: any): Observable<any> {
    return this.http.post<any>(`${environment.apiPrefix}${environment.user.user}`, data);
  }

  updateSubReseller(userId: string, data: any): Observable<any> {
    return this.http.put<any>(`${environment.apiPrefix}${environment.user.user}/${userId}`, data);
  }

  deleteSubReseller(userId: string): Observable<any> {
    return this.http.delete<any>(`${environment.apiPrefix}${environment.user.user}/${userId}`);
  }
}
